import { CredentialFileRendition } from "@api/shared-runtime/enums";
import {
  fetchCredentialFile,
  getCredentialFileUrls,
} from "@/ajax/documents/credential-file-urls";
import { saveBlob } from "@/ajax/documents/saveBlob";

/** Save one legacy credential file version under `fileName`. */
export const downloadFile = async ({
  userId,
  fileId,
  fileName,
  organizationBusinessUnitId,
}: {
  /** The documents' owner. */
  userId: string;
  /** A `user_credentials_file_version` id. */
  fileId: string;
  fileName: string;
  organizationBusinessUnitId?: string;
}) => {
  const [file] = await getCredentialFileUrls({
    switchUserId: userId,
    organizationBusinessUnitId,
    versions: [
      { versionId: fileId, rendition: CredentialFileRendition.Original },
    ],
  });
  const blob = await fetchCredentialFile(file);

  await saveBlob({ blob, fileName });

  return true;
};
